document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementsByClassName('content-table').length > 0) {
        const rows = document.querySelectorAll('tr[data-href]');
        const checkboxes = document.querySelectorAll('.b-checkbox');
        const headCheckbox = document.querySelector('.h-checkbox');
        const innerButtons = document.querySelectorAll('.button');
        const actionButton = document.querySelector('.action-button');

        // チェックボックスの状態に応じてアクションボタンの有効/無効を切り替える
        const updateButtonState = () => {
            if (!actionButton) {
                return;
            }
            actionButton.disabled = !Array.from(checkboxes).some(checkbox => checkbox.checked)
        }

        // チェックボックスが1つでもOFFの時、ヘッダーのチェックボックスもOFFにする
        const updateHeadCheckboxState = (checkbox) => {
            if(checkbox.checked) {
                return;
            }
            headCheckbox.checked = Array.from(checkboxes).every(checkbox => checkbox.checked)
        }

        // 行をクリックしたとき、data-href属性に指定されたURLに遷移する
        rows.forEach(row => {
            if (row.dataset.href === '') {
                return;
            }

            row.addEventListener('click', function(event) {
                if (event.target.type !== 'checkbox') {
                    window.location.href = this.dataset.href;
                }
            });
        });

        // チェックボックスをクリックしたとき、親要素のクリックイベントが発火しないようにする
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('click', function(event) {
                event.stopPropagation();
                updateButtonState();
                updateHeadCheckboxState(checkbox);
            });
        });

        // ボタンをクリックしたとき、親要素のクリックイベントが発火しないようにする
        innerButtons.forEach(button => {
            button.addEventListener('click', function(event) {
                event.stopPropagation();
                button.disabled = true;
                button.form.submit();
            });
        });

        // へッダーのチェックボックスをクリックしたとき、全てのチェックボックスの状態を変更する
        if (headCheckbox) {
            headCheckbox.addEventListener('click', function() {
                checkboxes.forEach(checkbox => {
                    checkbox.checked = headCheckbox.checked;
                });
                updateButtonState();
            });
        };

        // 初期表示の状態を更新
        updateButtonState();
    }
})
